import React, { useState } from 'react';
import { useStore } from "../teafuljs/store"
import { getTranslation } from "../scripts/getTranslation"
import YouTube from "@material-ui/icons/YouTube"
import CloseIcon from "@material-ui/icons/Close"
import SphereViewVideo from "./SphereViewVideos"
import { makeStyles, useTheme } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  root: {
    margin: '20px 0',
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  },
  categoryTitle: {
    // paddingBottom: 10,
    display: "flex",
    verticalAlign: "middle",
  },
  checkmark: {
    marginRight: 10,
  },
  title: {
    display: "block",
  },
}))

export default ({cat, hasVideo}) => {
  const classes = useStyles()
  const translations = useStore.translations()[0]
  const language = useStore.language()[0]
  const version = useStore.version()[0]
  const [showVideo, setShowVideo] = useState(false)
  return (
    <div className={classes.root}>
      <h2 key={cat} className={classes.categoryTitle}>
        {hasVideo ? <div>
          {!showVideo ? (
            <YouTube
              className={classes.checkmark}
              color="error"
              onClick={() => setShowVideo(!showVideo)}
            />
          ) : (
            <CloseIcon
              className={classes.checkmark}
              color="error"
              onClick={() => setShowVideo(!showVideo)}
            />
          )}
        </div> : null}
        <span className={classes.title}>
          {getTranslation(translations, language, "KeyPassages", cat)}
        </span>
      </h2>
      {showVideo ? (
        <SphereViewVideo language={language} version={version} id={cat} />
      ) : null}
    </div>
  )
}